import api from "../utils/axios/axiosConfig";

const statistiquesService = {
  metrics: (params) => api.post("/statistiques/metrics", params),
  latestLeads: (params) => api.post("/statistiques/latest_leads", params),
  financialStats: (params) => api.post("/statistiques/financial-stats", params),
};

export default statistiquesService;
